import { render } from "./dashboardAnnouncement.vue?vue&type=template&id=31bf8c5a"
import script from "./dashboardAnnouncement.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboardAnnouncement.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./dashboardAnnouncement.vue?vue&type=style&index=0&id=31bf8c5a&module=true&lang=css"
cssModules["$style"] = style0
if (module.hot) {
  module.hot.accept("./dashboardAnnouncement.vue?vue&type=style&index=0&id=31bf8c5a&module=true&lang=css", () => {
    cssModules["$style"] = style0
    __VUE_HMR_RUNTIME__.rerender("31bf8c5a")
  })
}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__file',"resources/js/vueComponents/admin/dashboardAnnouncement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31bf8c5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31bf8c5a', __exports__)) {
    api.reload('31bf8c5a', __exports__)
  }
  
  module.hot.accept("./dashboardAnnouncement.vue?vue&type=template&id=31bf8c5a", () => {
    api.rerender('31bf8c5a', render)
  })

}


export default __exports__